import { Box, Button, Grid, FormControlLabel, Switch } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { editUserPreferences } from 'api/user'
import { fetchNotifications } from 'api/notification'
import { closeModal } from 'actions/app'
import { useEffect } from 'react'
import { TEST_IDS } from 'test-ids'
import ModalHeader from 'components/modal/modal-header'
import ModalActions from 'components/modal/modal-actions'
import * as c from 'common/c'

export default function UserPreference() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const userPrefs = useSelector((state) => state.account.user['prefs'])

  const closePopup = useCallback(() => {
    dispatch(closeModal())
  }, [dispatch])

  const [prefs, setPrefs] = useState({})

  useEffect(() => {
    setPreferences(
      userPrefs
        ? userPrefs?.notifications.suppression
        : c.DEFAULT_NOTIFICATION_SUPPRESSION,
    )
  }, [userPrefs])

  const setPreferences = (notificationObj) => {
    const otherValue = notificationObj.other
    const prefs = Object.keys(notificationObj)
      .sort()
      .reduce((obj, key) => {
        if (key !== 'other') {
          obj[key] = notificationObj[key]
        }
        return obj
      }, {})
    prefs['other'] = otherValue
    setPrefs(prefs)
  }

  const handleChange = useCallback((e) => {
    const {
      target: { checked },
    } = e

    const categoryUpdated = e.target.name

    const reqBody = {
      path: `notifications.suppression.${categoryUpdated}`,
      value: !checked,
    }

    dispatch(editUserPreferences(reqBody)).then(() => {
      return dispatch(fetchNotifications())
    })
  })

  return (
    <Box sx={{ maxWidth: '600px' }}>
      <ModalHeader>{t('notification_categories')}</ModalHeader>
      <Grid
        container
        spacing={2}
        sx={{
          alignSelf: 'start',
        }}
      >
        {Object.keys(prefs).map((category) => (
          <Grid size={12} key={category}>
            <FormControlLabel
              value="enable"
              control={
                <Switch
                  color="primary"
                  onChange={handleChange}
                  name={category}
                />
              }
              label={t(category)}
              labelPlacement="start"
              checked={!prefs[category]}
            />
          </Grid>
        ))}
      </Grid>
      <ModalActions>
        <Button
          variant="contained"
          onClick={closePopup}
          data-testid={TEST_IDS.userPreferencesCloseButton}
        >
          {t('close')}
        </Button>
      </ModalActions>
    </Box>
  )
}
